import { useNavigate } from "react-router-dom";
import type { FamilyListItem } from "../../types/family";
import { Icon } from "../../components/Icon";

interface FamilyCardProps {
  family: FamilyListItem;
}

export function FamilyCard({ family }: FamilyCardProps) {
  const navigate = useNavigate();

  const roleLabel = family.role === "admin" ? "Администратор" : "Участник";

  return (
    <article className="h-full w-full rounded-[24px] border border-black/[0.04] bg-white p-5 text-left shadow-[0_12px_32px_rgba(35,33,25,0.06)] transition-[transform,box-shadow] hover:-translate-y-0.5 hover:shadow-[0_16px_36px_rgba(35,33,25,0.1)] lg:p-6">
      <div className="flex items-center gap-4">
        <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-[18px] bg-[#FFF0DF] text-[#FF7A00]">
          <Icon name="family" size={27} />
        </div>
        <div className="min-w-0 flex-1">
          <h3 className="truncate text-lg font-bold tracking-[-0.025em] text-[#171714]">
            {family.name}
          </h3>
          <p className="mt-1 text-sm text-[#77776F]">
            {family.member_count}{" "}
            {family.member_count === 1
              ? "участник"
              : family.member_count < 5
                ? "участника"
                : "участников"}
          </p>
          <span className="mt-2 inline-block rounded-full bg-[#F2F1EC] px-2.5 py-1 text-[10px] font-bold uppercase tracking-[0.08em] text-[#77776F]">
          {roleLabel}
          </span>
        </div>
      </div>
      <div className="mt-5 flex gap-2 border-t border-black/[0.05] pt-4">
        <button
          type="button"
          onClick={() => navigate(`/members/${family.family_member_id}/wishes`)}
          className="flex flex-1 cursor-pointer items-center justify-center gap-2 rounded-xl bg-[#171714] px-4 py-3 text-sm font-semibold text-white transition-transform hover:-translate-y-0.5"
        >
          <Icon name="gift" size={17} />
          Мои желания
        </button>
        <button
          type="button"
          onClick={() => navigate("/family")}
          aria-label={`Настройки семьи ${family.name}`}
          className="flex h-11 w-11 shrink-0 cursor-pointer items-center justify-center rounded-xl bg-[#F2F1EC] text-[#77776F] transition-colors hover:text-[#171714]"
        >
          <Icon name="settings" size={18} />
        </button>
      </div>
    </article>
  );
}
